import { getPagination } from '@/utils/helpers';
import {
    GET_LIST_REWARD_HISTORIES,
    GET_LIST_REWARD_CUSTOMER_HAS,
    REWARD_GET_CONFIG
} from '@/redux/actions/types';

const emptyList = {
    items: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 20
    }
};

const INITIAL_STATE = {
    rewards: emptyList,
    customerHas: emptyList,
    config: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_LIST_REWARD_HISTORIES:
            return {
                ...state,
                rewards: {
                    items: action.payload?.data || [],
                    pagination: getPagination(action.payload || {}, 20)
                }
            };
        case GET_LIST_REWARD_CUSTOMER_HAS:
            return {
                ...state,
                customerHas: {
                    items: action.payload?.data || [],
                    pagination: getPagination(action.payload || {}, 20)
                }
            };
        case REWARD_GET_CONFIG:
            return { ...state, config: action.payload || null };
        default:
            return state;
    }
};
